import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDoctorProfile } from '../../../../redux/middleware/user/doctor/profile.js';
import {
  Container,
  Typography,
  Card,
  CardContent,
  CircularProgress
} from '@mui/material';

const PendingApproval = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const doctorProfile = useSelector((state) => state.doctorProfile);
  const isVerified =
		doctorProfile?.is_verified ??
		localStorage.getItem('pendingApproval') === 'false';

  useEffect(() => {
    // Poll every 10 seconds to check approval status
    const interval = setInterval(() => {
      dispatch(fetchDoctorProfile());
    }, 10000);

    // Redirect to dashboard if verified
    if (isVerified) {
      navigate('/app/doctor/dashboard');
    }

    return () => clearInterval(interval);
  }, [isVerified, dispatch, navigate]);

  return (
    <Container
      maxWidth='sm'
      sx={{
			  display: 'flex',
			  justifyContent: 'center',
			  alignItems: 'center',
			  height: '100vh'
      }}
    >
      <Card
        elevation={3}
        sx={{ padding: 4, textAlign: 'center', width: '100%' }}
      >
        <Typography variant='h5' fontWeight='bold' gutterBottom>
          Your Profile is Under Review
        </Typography>
        <Typography variant='body1' color='textSecondary' gutterBottom>
          Our team is currently reviewing your profile. Once approved, you will
          be redirected to your dashboard.
        </Typography>
        <Typography variant='body1' color='textSecondary'>
          You will also receive a notification upon approval. If you log in
          after being approved, you will be taken directly to your dashboard.
        </Typography>
        <CircularProgress sx={{ marginTop: 3 }} />
      </Card>
    </Container>
  );
};

export default PendingApproval;
